import {Component, OnInit} from '@angular/core';
import {SenderService} from '../../../../services/sender.service';
import {ModalService} from '../../../../services/modal.service';

@Component({
  selector: 'app-add-form-post-input',
  templateUrl: './add-form-post-input.component.html',
  styleUrls: ['./add-form-post-input.component.scss']
})
export class AddFormPostInputComponent implements OnInit {

  constructor(
    public modalService: ModalService,
    public senderService: SenderService,
  ) { }

  ngOnInit(): void {
    /*this.senderService.senderForm.get('post_link').valueChanges.pipe(debounceTime(1000)).subscribe((v) => {
      alert('!');
      if (v?.length < 3) { return; }
      log('postLinkDetail', v);
      delete this.senderService.chatInfo;
      delete this.senderService.errorPostLinkDetail;
      this.senderService.loadedChatDetail = false;
      this.cd.detectChanges();
      const clearContact = this.telegramService.clearContact(v);
      const telegramService = (this.allMessengersService.getServicesFilter('isAuth', true)
        .find((Service) => Service instanceof TelegramService) as TelegramService);

      telegramService.getDetailInfo(clearContact, false, 1, true).subscribe((res) => {
        this.senderService.chatInfo = res;
        this.senderService.loadedChatDetail = true;
        this.cd.detectChanges();
      }, error => {
        delete this.senderService.chatInfo;
        delete this.senderService.errorPostLinkDetail;
        // TODO отключил потому что часто лагало
        if (error?.status === 404 || error?.status === 403) {
          this.senderService.errorPostLinkDetail = this.interfaceService.errorHandling(error, false);
        }
        this.senderService.loadedChatDetail = true;
        this.cd.detectChanges();
      });
    });*/
  }

}
